import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { userApi } from '../userApi';

export const useGetUser = (id: string) => {
  return useQuery({
    queryKey: [QueryKey.GET_USER, id],
    queryFn: () => userApi.getUser(id),
    retry: false,
  });
};
